import React, { useEffect, FC, useContext } from 'react';
import { Dimensions, StyleSheet } from 'react-native';
import { Text, View, ScrollView, Pressable, Image, ANIMATION_TYPES } from '@flexn/create';
import Screen from '../screen';
import { ThemeContext, ROUTES, Ratio } from '../../config';
import { useQuery } from 'react-query';
import * as Progress from 'react-native-progress';

// screen size
const windowWidth: any = Dimensions.get('window').width;
const windowHeight: any = Dimensions.get('window').height;

interface Props {
    channel: any
    navigation: any
    ch_menu_category: string;
}

const Osd: FC<Props> = ({ channel, navigation, ch_menu_category }) => {

    const { theme } = useContext(ThemeContext);

    const [date, setDate] = React.useState(new Date());
    const [time, setTime] = React.useState("");

    React.useEffect(() => {
        var timer = setInterval(() => setDate(new Date()), 1000);
        return function cleanup() {
            clearInterval(timer)
        }
    });

    useEffect(() => {

        const intervalId = setInterval(() => {

            const date = new Date();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const timeString = hours + ':' + (minutes < 10 ? '0' + minutes : minutes);

            setTime(timeString);

        }, 5);

        return () => clearInterval(intervalId);

    }, []);

    return (
        <Screen style={[styles.osd]} focusOptions={{ screenOrder: 2 }}>
            <View style={styles.logoSection}>
                <Image resizeMode="contain" style={styles.channelLogo} source={{ uri: `${channel['stream_icon']}` }} />
            </View>
            <View style={styles.contentSection}>
                <View style={{ marginTop: 0 }}>
                    <Text style={styles.title} >{channel['num']}  {channel['name']}</Text>
                    <View style={{ marginTop: 5 }}>
                        <View>
                            <Text style={{ color: "#ddd", fontSize: Dimensions.get("window").width / 70, marginLeft: 5 }}>Programs of {channel.name}</Text>
                        </View>
                    </View>
                </View>
                <View style={{ flexDirection: "row", marginTop: 25 }}>
                    <Pressable
                        style={{
                            backgroundColor: "#222",
                            width: Dimensions.get("window").width / 6.5,
                            height: Dimensions.get("window").width / 35,
                            borderRadius: 15,
                            justifyContent: "center",
                            marginTop: 5,
                            marginLeft: 0
                        }}
                        onPress={() => navigation.navigate(ROUTES.CHANNEL_LIST_TV, { category: ch_menu_category })}
                        focusOptions={{
                            animator: {
                                type: 'background',
                                focus: {
                                    backgroundColor: '#128DD3'
                                },
                            }
                        }}
                    >
                        <Text style={{ color: "#fff", textAlign: "center", fontSize: Dimensions.get("window").width / 90, marginBottom: 2 }}>Channels Menu</Text>
                    </Pressable>
                </View>
            </View>
            <View style={{ justifyContent: "center", marginLeft: -15 }}>
                <Text style={{ color: "#ddd", fontSize: Dimensions.get("window").width / 70, marginBottom: -7 }}>{date.toDateString()}</Text>
                <Text style={{ color: "#ddd", fontSize: Dimensions.get("window").width / 30, fontWeight: "bold" }}>{time}</Text>
            </View>
        </Screen>
    )
}

const styles = StyleSheet.create({
    osd: {
        backgroundColor: "#111",
        width: windowWidth,
        height: windowHeight / 3,
        padding: 10,
        alignSelf: "center",
        position: 'absolute',
        zIndex: 1,
        bottom: 0,
        opacity: 0.9,
        flexDirection: "row"
    },
    title: {
        fontSize: Dimensions.get("window").width / 40,
        color: "white",
        fontWeight: "bold"
    },
    logoSection: {
        alignItems: "center",
        justifyContent: "center",
        flexBasis: "15%"
    },
    contentSection: {
        flexBasis: "70%",
        alignContent: "center",
        justifyContent: "center",
        marginLeft: 10
    },
    timeSection: {
        flexBasis: "15%",
        alignContent: "center",
        justifyContent: "center",
        marginLeft: 10
    },
    channelLogo: {
        width: windowWidth / 9,
        height: windowWidth / 9,
    },
    description: {
        color: "white",
        marginTop: 5
    }
});

export default Osd;